const DISHES = [
    {
        id: 0,
        name: 'Pizza',
        image:" https://cdn.pixabay.com/photo/2020/06/08/16/49/pizza-5275191__340.jpg",
        category:'meal',
        label:'Hot',
        price:'199',
        featured:true,
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Delectus, ab! Quis magnam sapiente vero omnis. Sequi molestias hic et delectus!",
        
    },
    {
        id: 1,
        name: 'Hamburger',
        image:"https://cdn.pixabay.com/photo/2016/03/05/19/02/hamburger-1238246__340.jpg",
        category:'meal',
        label:'Hot',
        price:'199',
        featured:true,
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Delectus, ab! Quis magnam sapiente vero omnis. Sequi molestias hic et delectus!",
        
    },
    {
        id: 2,
        name: 'Meat skewer',
        image:"https://cdn.pixabay.com/photo/2016/06/06/18/29/meat-skewer-1440105__340.jpg",
        category:'meal',
        label:'Hot',
        price:'199',
        featured:true,
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Delectus, ab! Quis magnam sapiente vero omnis. Sequi molestias hic et delectus!",
       
    },
    {
        id: 3,
        name: 'Cake',
        image:"https://cdn.pixabay.com/photo/2016/03/27/22/38/cake-1284548__340.jpg",
        category:'meal',
        label:'Hot',
        price:'199',
        featured:false,
        description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Delectus, ab! Quis magnam sapiente vero omnis. Sequi molestias hic et delectus!",
        
    },
]


export default DISHES;